export default __webpack_public_path__ + "static/media/Science.b9be8e1a.png";